import React from "react";
import { Divider, Box, makeStyles, RaiseColors } from "client/componentLibrary";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    cardContainer: {
      position: "relative",
      display: "flex",
      margin: "20px 8px 20px 0px"
    },
    carousel: {
      cursor: "pointer",
      "& img": {
        height: 172,
        width: 258,
        borderRadius: "4px",
        display: "block"
      }
    },
    body: {
      margin: "8px 40px 8px 20px",
      minWidth: 0,
      "&:hover": {
        cursor: "pointer"
      }
    },
    subtext: {
      margin: "4px 0px 22px 0px"
    },
    divider: {
      margin: "8px 0px",
      width: "24px"
    },
    coreAttributes: {
      display: "flex",
      width: "264px",
      maxWidth: "264px"
    }
  };
});
export var HorizontalListingCardLoading = function HorizontalListingCardLoading(_ref) {
  var FileCarouselSection = _ref.FileCarouselSection,
    useLineDivider = _ref.useLineDivider;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: classes.cardContainer,
      children: [/*#__PURE__*/_jsx("div", {
        className: classes.carousel,
        children: FileCarouselSection
      }), /*#__PURE__*/_jsxs("div", {
        className: classes.body,
        children: [/*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Box, {
            bgcolor: RaiseColors.gray200,
            width: 120,
            height: 14
          }), /*#__PURE__*/_jsx("div", {
            className: classes.divider,
            children: /*#__PURE__*/_jsx(Divider, {
              color: RaiseColors.gray100
            })
          })]
        }), /*#__PURE__*/_jsx(Box, {
          bgcolor: RaiseColors.gray200,
          width: 120,
          height: 14
        }), /*#__PURE__*/_jsx(Box, {
          className: classes.subtext,
          bgcolor: RaiseColors.gray200,
          width: 220,
          height: 14
        }), /*#__PURE__*/_jsxs(Box, {
          className: classes.coreAttributes,
          mt: 8,
          children: [/*#__PURE__*/_jsxs(Box, {
            width: "50%",
            children: [/*#__PURE__*/_jsx(Box, {
              bgcolor: RaiseColors.gray200,
              width: 100,
              height: 14
            }), /*#__PURE__*/_jsx(Box, {
              bgcolor: RaiseColors.gray200,
              width: 100,
              height: 14,
              mt: 0.5
            })]
          }), /*#__PURE__*/_jsxs(Box, {
            ml: 2.5,
            children: [/*#__PURE__*/_jsx(Box, {
              bgcolor: RaiseColors.gray200,
              width: 100,
              height: 14
            }), /*#__PURE__*/_jsx(Box, {
              bgcolor: RaiseColors.gray200,
              width: 100,
              height: 14,
              mt: 0.5
            })]
          })]
        })]
      })]
    }), useLineDivider && /*#__PURE__*/_jsx(Divider, {
      color: RaiseColors.gray100
    })]
  });
};
export default HorizontalListingCardLoading;